(() => {
  // Judge.me may render after page load or refresh its widgets dynamically.
  const cleanCounts = () => {
    document.querySelectorAll('.jdgm-rating-text, .jdgm-subtab__name').forEach(label => {
      if (!label.querySelector('.jdgm-reviews-count, .jdgm-subtab__count')) return;
      label.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && /[()]/.test(node.textContent)) {
          node.textContent = node.textContent.replace(/[()]/g, '');
        }
      });
    });
    document.querySelectorAll('.jdgm-widget .jm-text').forEach(label => {
      if (/^\s*[\d,.]+\s+reviews?\s*$/i.test(label.textContent)) {
        label.classList.add('namami-review-count');
      }
    });
  };
  let pending = false;
  const observer = new MutationObserver(records => {
    if (pending || !records.some(record =>
      record.target.nodeType === Node.ELEMENT_NODE &&
      (record.target.closest('.jdgm-widget') ||
        [...record.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE &&
          (node.matches('.jdgm-widget') || node.querySelector('.jdgm-widget'))))
    )) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; cleanCounts(); });
  });
  cleanCounts();
  observer.observe(document.body, { childList: true, subtree: true });
})();
